import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { CartAPI, CACHE_KEY } from 'src/routes/(shop)/api/cart'
import { UPDATE_CART_SUMMARY } from 'shared/constants'
import { CartSummary as Component } from './CartSummary'

interface CartSummaryProps {
  isCompact?: boolean
}

export const CartSummary: React.FC<CartSummaryProps> = ({ isCompact }) => {
  const queryClient = useQueryClient()
  const { data, isLoading, error } = CartAPI.useShow()

  useEffect(() => {
    PubSub.subscribe(UPDATE_CART_SUMMARY, () => {
      queryClient.invalidateQueries(CACHE_KEY)
    })
  })

  if (isLoading) return null
  if (error) return <div>Error loading cart data</div>
  if (!data || !data.checkoutTotals) return null

  return <Component isCompact={isCompact} {...data} />
}
